<template>
    <div ref="index" class="index relative w-full h-screen" :style="{backgroundColor : (currentIndex === 0 && !currentCasestudy) ? '#000' : '#FFF'}">
        <div class="index__case-studies">
            <template v-for="(caseStudy, index) in casestudies">
                <home-case-study
                        :key="index"
                        v-if="currentIndex === index"
                        class="index__case-study"
                        :number="caseStudy.caseStudyNumbers"
                        :numberWidth="caseStudy.caseStudyNumbersWidth"
                        :client="caseStudy.caseStudyClient"
                        :slug="caseStudy.slug"
                        :image="caseStudy.caseStudyOverviewImage"
                        v-touch:swipe="scrollHandler"
                ></home-case-study>
            </template>
        </div>
        <div class="index__nav w-full max-w-4xl px-10">
            <home-navigation :casestudies="casestudies" :current-index="currentIndex" @DOTCLICKED="goToIndex($event)"></home-navigation>
        </div>
        <div class="index__intro-stuff">
            <div ref="logoContainer" class="index__logo-container overflow-hidden" key="introLogo">
                <logo ref="introLogo" class="index__intro-logo w-62" style="fill : white"></logo>
            </div>
            <transition @enter="introStuffEnter">
                <p v-if="homepage" ref="introCatchphrase" class="index__intro-text font-signal-regular text-white text-2xl md:text-2-5xl leading-tight"><span v-html="homepage[0].homepagePresentation.content"></span></p>
            </transition>
            <img ref="introFilets" class="index__intro-filets" src="@/assets/images/intro-filets.png" />
        </div>
    </div>
</template>

<script>
    import logo from '../assets/svg/designus-logo.svg';
    import { mapState, mapMutations } from 'vuex';
    import {TweenMax, Power3 } from 'gsap';
    import HomeCaseStudy from '../components/HomeCaseStudy';
    import HomeNavigation from '../components/HomeNavigation';
    import gql from 'graphql-tag';

    export default {

        components: {HomeNavigation, HomeCaseStudy, logo},

        data() {
            return {
                currentIndex: 0,

                goneDown: false,

                animating: false,

                lastY : 0
            }
        },

        computed : {
            ...mapState([
                'currentCasestudy'
            ])
        },

        watch: {
            currentIndex() {
                // If index < 0, stay at 0
                if (this.currentIndex < 0) this.currentIndex = (this.goneDown) ? this.casestudies.length - 1 : 0;

                // If index > max, stay at max
                if (this.currentIndex > this.casestudies.length - 1) this.currentIndex = 0;

                this.$store.commit('updateCurrentCasestudy', this.currentIndex);

                if(this.currentIndex === 0) {
                    this.introStuffEnter();
                }

                // If we passed at least one step
                if (this.currentIndex > 0) {
                    // Flag the change
                    this.goneDown = true;
                }

                // If index is at 0, intro => go white
                if (this.currentIndex === 0) {
                    this.$store.commit('updateHeaderColor', 'white');
                } else {
                    this.$store.commit('updateHeaderColor', 'black');
                }
            }
        },

        apollo: {
            homepage: {
                query: gql`query {
                    homepage : entries(title:"Homepage") {
                    ... on Homepage {
                            homepagePresentation {content}
                        }
                    }
                }`,
            },

            casestudies : {
                query : gql`query {
                    casestudies : entries(type:CaseStudy){
                    ... on CaseStudy {
                            id
                            title
                            slug
                            caseStudyOverviewImage{
                                url
                                width
                                height
                            }
                            caseStudyNumbers
                            caseStudyNumbersWidth
                            caseStudyClient
                        }
                    }
                }`,

                result({data}){
                    this.$store.commit('updateCaseStudies', data.casestudies);

                    this.init();
                }
            }
        },

        mounted() {
            // Save the logo width
            this.$refs.logoContainer.setAttribute('data-width', this.$refs.logoContainer.clientWidth);

            TweenMax.set(this.$refs.logoContainer, {width : 0});
        },

        beforeDestroy(){
            document.removeEventListener('mousewheel', this.scrollHandler);
        },

        methods: {
            init(){
                if(!this.currentCasestudy) {
                    TweenMax.set(this.$refs.logoContainer, {
                        width : 0,
                        display : 'none'
                    });

                    this.hideNav(0);
                }

                // Event on scroll
                document.addEventListener('mousewheel', this.scrollHandler);

                if(this.currentCasestudy) {
                    TweenMax.set(this.$refs.logoContainer, {
                        width : 0,
                        display : 'none'
                    });

                    this.introStuffLeave();

                    this.initializeAtIndex(this.currentCasestudy);
                } else {
                    console.log('else');
                    this.$store.commit('updateHeaderColor', 'white');
                    // this.showNav();
                    // this.goToIndex(0);
                    this.introStuffEnter();
                }


                setTimeout(() => {
                    if(!this.currentCasestudy) {
                        this.showNav();
                    }
                }, 100);
            },
            /**
             * ON SCROLL
             * @param pEvent
             * @returns {Promise<void>}
             */
            async scrollHandler(pEvent) {
                let direction = null;

                // Get the direction
                if(pEvent.wheelDeltaY) {
                    direction = (pEvent.wheelDeltaY > 0) ? -1 : 1;
                } else if (typeof(pEvent) === "string") {
                    if(pEvent === 'left') {
                        direction = 1;
                    } else if (pEvent === 'right') {
                        direction = -1;
                    }
                }

                // If we aren't already animating
                if (!this.animating && (this.goneDown || (!this.goneDown && direction === 1))) {
                    // Start the animation
                    this.animating = true;

                    if(this.currentIndex === 0) {
                        this.introStuffLeave();
                    }

                    if(this.currentIndex + direction <= 0 || this.currentIndex === 0) {
                        this.hideNav();
                    }

                    await this.caseStudyLeave();

                    // Update the current index
                    this.currentIndex += direction;

                    if(this.currentIndex === 0) {
                        this.introStuffEnter();
                    }

                    this.showNav();

                    await this.caseStudyEnter();

                    this.animating = false;
                }
            },

            /**
             * Play animation to enter on child component
             * @returns {Promise<*>}
             */
            async caseStudyEnter() {
                return new Promise(resolve => {
                    HomeCaseStudy.methods.caseStudyEnter(resolve);
                });
            },

            /**
             * Play animation to enter on child component
             * @returns {Promise<*>}
             */
            async caseStudyLeave() {
                return new Promise(resolve => {
                    HomeCaseStudy.methods.caseStudyLeave(resolve);
                });
            },

            async initializeAtIndex(pIndex) {
                if (!this.animating) {
                    // Update the current index
                    this.currentIndex = pIndex;

                    this.showNav();

                    await this.caseStudyEnter();

                    this.animating = false;
                }
            },

            async goToIndex(pIndex){

                if (!this.animating) {
                    // Start the animation
                    this.animating = true;

                    if (this.currentIndex === 0) {
                        this.introStuffLeave();
                    }

                    if (pIndex <= 0 || this.currentIndex === 0) {
                        this.hideNav();
                    }

                    await this.caseStudyLeave();

                    // Update the current index
                    this.currentIndex = pIndex;

                    if (this.currentIndex === 0) {
                        this.introStuffEnter();
                    }

                    this.showNav();

                    await this.caseStudyEnter();

                    this.animating = false;
                }
            },

            introStuffEnter() {
                // Hide header logo
                TweenMax.to(document.querySelector('.header__logo'), 0.5, {
                    opacity : 0
                });

                if(this.$refs.logoContainer.getAttribute('data-width') === '0') {
                    // Show logo
                    TweenMax.set(this.$refs.logoContainer, {
                        display: 'block',
                        width : 'auto'
                    });

                } else {
                    // Show logo
                    TweenMax.fromTo(this.$refs.logoContainer, 0.5, {
                        width : 0
                    },{
                        display : 'block',
                        width : this.$refs.logoContainer.getAttribute('data-width'),
                        force3D : false,
                        ease : Power3.easeOut
                    });

                }


                // Show catchphrase & filets
                TweenMax.to([this.$refs.introCatchphrase, this.$refs.introFilets], 0.4, {
                    display : 'block',
                    opacity : 1,
                    force3D : false,
                    ease : Power3.easeOut
                });
            },

            introStuffLeave() {
                // Hide header logo
                TweenMax.to(document.querySelector('.header__logo'), 0.5, {
                    opacity : 1
                });

                // Save the logo width
                this.$refs.logoContainer.setAttribute('data-width', this.$refs.logoContainer.clientWidth);
                document.querySelector('.header__nav').setAttribute('data-height', document.querySelector('.header__nav').clientWidth);

                // Hide logo
                TweenMax.to(this.$refs.logoContainer, 0.5, {
                    width : 0,
                    display : 'none',
                    force3D : false,
                    ease : Power3.easeOut
                });

                // Hide catchphrase & filets
                TweenMax.to([this.$refs.introCatchphrase, this.$refs.introFilets], 0.4, {
                    display : 'none',
                    opacity : 0,
                    force3D : false,
                    ease : Power3.easeOut
                });
            },

            showNav(){
                TweenMax.to(document.querySelector('.header__nav'), 0.4, {
                    y : 0,
                    force3D : false,
                });

                TweenMax.to(document.querySelector('.header__nav .header__profile-link'), 0.4, {
                    x : 0,
                    force3D : false,
                });
            },

            hideNav(pDuration){
                TweenMax.to(document.querySelector('.header__nav'), (pDuration) ? pDuration : 0.4, {
                    y : - document.querySelector('.header__nav').getAttribute('data-height'),
                    force3D : false,
                });

                TweenMax.to(document.querySelector('.header__nav .header__profile-link'), (pDuration) ? pDuration : 0.4, {
                    x : document.querySelector('.header__nav').getAttribute('data-height'),
                    force3D : false,
                });
            },

            ...mapMutations([
                'updateHeaderColor',
                'updateCaseStudies',
                'updateCurrentCasestudy'
            ])
        }
    }
</script>

<style lang="scss">
    @import "../assets/styles/_globals.scss";

    .index {
        transition: background-color 0.3s ease-out;

        &__logo-container {
            @include top-left(50%, 50%);
            margin-top: -90px;
            margin-left: -120px;

            @media(min-width : 768px) {
                @include top-left(50%, 50%);
                margin-left: -560px;
                margin-top: -152px;
            }
        }

        &__intro-text {
            @include top-left(50%, 50%);
            margin-top: 43px;
            margin-left: -120px;

            @media(min-width : 768px) {
                @include top-left(50%, 50%);
                margin-top: 225px;
                margin-left: 200px;
            }

            display : none;
            opacity : 0;
        }

        &__intro-filets {
            @include top-left(50%, 50%);
            margin-top: -202px;
            margin-left: 360px;

            display : none;
            opacity : 0;
        }

        &__case-study {
            @include top-left(50%, 50%);
            transform: translate(-50%, -50%);

            &:not(:first-child) {
                display: none;
            }
        }

        &__case-study:first-child {
            .home-case-study__numbers-container{
                transform : translate(-50%, 0%);
            }

            .home-case-study__numbers {
                transform : translateY(0%);
            }
        }

        &__nav {
            @include bottom-left(92px, 50%);
            transform:  translateX(-50%);
            @media (min-width : 768px) {
                @include bottom-left(42px, 50%);
            }
        }
    }
</style>
